import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) => {
  return {
    container: {
      display: 'flex',
    },
    content: {
      width: '100%',
    },
    main: {
      // Header height: 71px
      maxHeight: 'calc(100vh - 71px)',
      overflowY: 'scroll',
    },
    mainWithFooter: {
      // Footer height: 102px
      maxHeight: 'calc(100vh - 71px - 102px)',
    },
  };
});

export default useStyles;
